import { render, staticRenderFns } from "./electricBagDetail.vue?vue&type=template&id=7a8aaf66&scoped=true&"
import script from "./electricBagDetail.vue?vue&type=script&lang=js&"
export * from "./electricBagDetail.vue?vue&type=script&lang=js&"
import style0 from "./electricBagDetail.vue?vue&type=style&index=0&id=7a8aaf66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8aaf66",
  null
  
)

export default component.exports